import OCR from "../../plugins/protokol/api/media/ocr"

const api = new OCR()

const ocrModels = {
    namespaced: true,

    state: () => ({
        models: [],
        currentModel: null,
        extractResult: null,
        loading: false,
        plan: null,
    }),

    mutations: {
        SET_MODELS(state, models) {
            state.models = models
        },
        SET_CURRENT_MODEL(state, model) {
            state.currentModel = model
        },
        ADD_MODEL(state, model) {
            state.models.push(model)
        },
        UPDATE_MODEL(state, model) {
            const idx = state.models.findIndex(m => m.uuid === model.uuid)
            if (idx !== -1) state.models.splice(idx, 1, model)
            if (state.currentModel && state.currentModel.uuid === model.uuid) {
                state.currentModel = model
            }
        },
        REMOVE_MODEL(state, uuid) {
            state.models = state.models.filter(m => m.uuid !== uuid)
            if (state.currentModel && state.currentModel.uuid === uuid) {
                state.currentModel = null
            }
        },
        SET_EXTRACT_RESULT(state, result) {
            state.extractResult = result
        },
        SET_LOADING(state, loading) {
            state.loading = loading
        },
        SET_PLAN(state, plan) {
            state.plan = plan
        },
    },

    actions: {
        async fetchModels({ commit }) {
            commit('SET_LOADING', true)
            try {
                const { data } = await api.listModels()
                commit('SET_MODELS', data)
                return data
            } finally {
                commit('SET_LOADING', false)
            }
        },

        async fetchModel({ commit }, uuid) {
            commit('SET_LOADING', true)
            try {
                const { data } = await api.getModel(uuid)
                commit('SET_CURRENT_MODEL', data)
                return data
            } finally {
                commit('SET_LOADING', false)
            }
        },

        async createModel({ commit }, payload) {
            const { data } = await api.createModel(payload)
            commit('ADD_MODEL', data)
            return data
        },

        async updateModel({ commit }, { uuid, ...payload }) {
            const { data } = await api.updateModel(uuid, payload)
            commit('UPDATE_MODEL', data)
            return data
        },

        async deleteModel({ commit }, uuid) {
            await api.deleteModel(uuid)
            commit('REMOVE_MODEL', uuid)
        },

        async addSample({ commit }, { modelUuid, ...payload }) {
            const { data } = await api.addSample(modelUuid, payload)
            return data
        },

        async updateSample(_, { modelUuid, sampleUuid, ...payload }) {
            const { data } = await api.updateSample(modelUuid, sampleUuid, payload)
            return data
        },

        async removeSample(_, { modelUuid, sampleUuid }) {
            await api.removeSample(modelUuid, sampleUuid)
        },

        async fetchPlan({ commit }) {
            try {
                const { data } = await api.getPlan()
                commit('SET_PLAN', data)
                return data
            } catch {
                commit('SET_PLAN', null)
                return null
            }
        },

        async extract({ commit }, payload) {
            commit('SET_LOADING', true)
            try {
                const { data } = await api.extract(payload)
                commit('SET_EXTRACT_RESULT', data)
                return data
            } finally {
                commit('SET_LOADING', false)
            }
        },
    },

    getters: {
        models: state => state.models,
        currentModel: state => state.currentModel,
        extractResult: state => state.extractResult,
        loading: state => state.loading,
        plan: state => state.plan,
        isPaidPlan: state => state.plan && state.plan.plan === 'paid',
    },
}

export default ocrModels
